<va-filter-container
  [toolbarText]="productToolbarText$ | async"
  [searchable]="true"
  (searchTermChanged)="handleSearchFilter($event)"
>
  <p class="growth-header" header>
    {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.SHOW_GROWTH_OVER' | translate }}
  </p>
  <span header>
    <div class="filter-container">
      <va-filter-chip-container [filters]="filters" [config]="config"></va-filter-chip-container>
    </div>
  </span>
</va-filter-container>
<ng-container *ngTemplateOutlet="productTable; context: { dataSource: dataSource, showHeaders: true }"></ng-container>
<ng-template #productTable let-dataSource="dataSource" let-showHeaders="showHeaders">
  <mat-table
    class="product-table"
    content
    matSort
    [dataSource]="dataSource"
    multiTemplateDataRows
    #manageProductSort="matSort"
    [matSortActive]="Columns.ActiveAccounts"
    matSortStart="desc"
    matSortDirection="desc"
    [trackBy]="trackByFn"
    matSortDisableClear
  >
    <!-- Product Column -->
    <ng-container [matColumnDef]="Columns.Product">
      <mat-header-cell class="product-column" *matHeaderCellDef mat-sort-header>
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.PRODUCT' | translate }}
      </mat-header-cell>
      <mat-cell class="product-column" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <div class="product-cell" [class.indented-column]="!showHeaders">
            <div class="icon-container">
              <a [routerLink]="getProductId(element)">
                <va-icon [diameter]="40" [iconName]="element?.name" [iconUrl]="element?.icon"></va-icon>
              </a>
            </div>
            <div class="product-info-container">
              <a [routerLink]="getProductId(element)">{{ element.name }}</a>
              <p class="product-requirements-text" *ngIf="element.addonId">
                {{
                  'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.PARENT_REQUIREMENT'
                    | translate
                      : {
                          name: ((appIdToNameMap$ | async) || {})[element.appId]
                        }
                }}
              </p>
              <p class="product-tagline-text" *ngIf="element.tagline">
                {{ element.tagline }}
              </p>
            </div>
          </div>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Selling in store Column -->
    <ng-container [matColumnDef]="Columns.SellingInStore">
      <mat-header-cell class="center-align small-column" *matHeaderCellDef>
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.SELLING_IN_STORE' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell center-align small-column" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <span *ngIf="element.sellingInStore"><mat-icon>check</mat-icon></span>
          <span *ngIf="!element.sellingInStore">&mdash;</span>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Active Accounts -->
    <ng-container [matColumnDef]="Columns.ActiveAccounts">
      <mat-header-cell
        class="right-align currently-active-column"
        *matHeaderCellDef
        mat-sort-header
        arrowPosition="before"
      >
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.ACTIVE_ACCOUNTS' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell right-align currently-active-column" *matCellDef="let element">
        <div style="display: flex; flex-direction: column">
          <ng-container *ngIf="element; else loadingCell">
            <div>
              {{ element.stats?.activations - element.stats?.deactivations }}
            </div>
          </ng-container>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Vertical Line -->
    <ng-container [matColumnDef]="Columns.VerticalLine">
      <mat-header-cell class="line-column" *matHeaderCellDef>
        <mat-divider [vertical]="true" class="divider"></mat-divider>
      </mat-header-cell>
      <mat-cell class="line-column" *matCellDef>
        <mat-divider [vertical]="true" class="divider"></mat-divider>
      </mat-cell>
    </ng-container>

    <!-- Activations Column -->
    <ng-container [matColumnDef]="Columns.Activations">
      <mat-header-cell class="right-align" *matHeaderCellDef mat-sort-header arrowPosition="before">
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.ACTIVATIONS' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell right-align pos" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <span [ngClass]="element.change?.activations > 0 ? 'pos' : 'zero'">
            {{ element.change?.activations > 0 ? '+' : '' }}{{ element.change?.activations }}
          </span>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Pending Cancellations Column -->
    <ng-container [matColumnDef]="Columns.Cancellations">
      <mat-header-cell class="right-align" *matHeaderCellDef mat-sort-header arrowPosition="before">
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.PENDING_DEACTIVATIONS' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell right-align" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <span class="zero">
            {{ element.change?.cancellations }}
          </span>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Deactivations Column -->
    <ng-container [matColumnDef]="Columns.Deactivations">
      <mat-header-cell class="right-align" *matHeaderCellDef mat-sort-header arrowPosition="before">
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.DEACTIVATIONS' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell right-align" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <span [ngClass]="element.change?.deactivations > 0 ? 'neg' : 'zero'">
            {{ element.change?.deactivations > 0 ? '-' : '' }}{{ element.change?.deactivations }}
          </span>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Growth Column -->
    <ng-container [matColumnDef]="Columns.Growth">
      <mat-header-cell class="right-align" *matHeaderCellDef mat-sort-header arrowPosition="before">
        {{ 'FRONTEND.STORE.MANAGE_PRODUCT.MANAGE_PRODUCT_TABLE.COLUMNS.GROWTH' | translate }}
      </mat-header-cell>
      <mat-cell class="stat-cell right-align growth-cells" *matCellDef="let element">
        <ng-container *ngIf="element && element.change && element.stats; else loadingCell">
          <span [ngClass]="element.growth > 0 ? 'pos' : element.growth < 0 ? 'neg' : 'zero'">
            {{ element.growth > 0 ? '+' : '' }}{{ element.growth }}%
          </span>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Actions Column -->
    <ng-container [matColumnDef]="Columns.Actions">
      <mat-header-cell class="right-align marketplace-button" *matHeaderCellDef></mat-header-cell>
      <mat-cell class="stat-cell right-align marketplace-button" *matCellDef="let element">
        <ng-container *ngIf="element; else loadingCell">
          <button mat-flat-button *ngIf="element.addons?.length > 0">
            <mat-icon *ngIf="!element.expanded; else showLess">expand_more</mat-icon>
            <ng-template #showLess>
              <mat-icon>expand_less</mat-icon>
            </ng-template>
          </button>
        </ng-container>
      </mat-cell>
    </ng-container>

    <!-- Expandable Addons Column -->
    <ng-container matColumnDef="expandedDetail">
      <mat-cell class="addons-cell" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div *ngIf="element?.addons?.length > 0 && element?.expanded" class="expandable-col">
          <ng-template
            *ngTemplateOutlet="productTable; context: { dataSource: element.addons, showHeaders: false }"
          ></ng-template>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container *ngIf="showHeaders">
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    </ng-container>
    <mat-row
      class="product-row"
      *matRowDef="let row; columns: displayedColumns"
      [class.expandable]="row?.addons?.length > 0"
      (click)="row.expanded = !row.expanded"
    ></mat-row>
    <mat-row class="addons-row" *matRowDef="let element; columns: ['expandedDetail']"></mat-row>
  </mat-table>
</ng-template>
<ng-template #loadingCell>
  <td class="stencil-container">
    <div class="stencil stencil-shimmer"></div>
  </td>
</ng-template>
